import React, { useState, useEffect, useRef, useMemo } from "react";
import "./styles.scss";

import ProfilePicture from "../../../shared/ProfilePicture";
import HvButton from "../../../shared/HvButton";
import { ReactComponent as LocationIcon } from "../../../../../public/shared/white-location-icon.svg";
import { ReactComponent as EditIcon } from "../../../../../public/shared/white-pencil-icon.svg";
import { ReactComponent as NewMessage } from "../../../../..//public/icons/UserProfile/newMessage.svg";
import { ReactComponent as CopyLink } from "../../../../..//public/icons/UserProfile/copyLink.svg";
import { Link } from "react-router-dom";
import { isSelfId } from "../../../../../api/helper";
import FollowButton from "../../../WhoToFollow/FollowButton";
import SendNewMessage from "../../../shared/SendNewMessage";
import CopyToClipBoard from "../../../shared/CopyToClipBoard";
import { NavLink } from "react-router-dom";
import store from "../../../../../redux/store";
import RollOver from "../../../../RollOver";

export default ({ user }) => {
  const [tooltip, setTooltip] = useState("copy link");

  const copyMe = useMemo(
    () =>
      user.shareable_link
        ? user.shareable_link.indexOf("https://") == 0
          ? user.shareable_link
          : "https://" + user.shareable_link
        : "https://" + window.location.host + "/" + user.slug,
    [user]
  );

  const copyMeEpk = useMemo(
    () =>
      user.web_link
        ? user.web_link.indexOf("https://") == 0
          ? user.web_link
          : "https://" + user.web_link
        : "https://" + window.location.host + "/" + user.slug,
    [user]
  );

  return user ? (
    <div className="info my-5 pt-5 d-md-flex">
      <ProfilePicture className="mr-3" user={user} />
      <div className="meta">
        <p className="text-white text-capitalize">
          <span className="text-uppercase user-type-text">{user.user_type}</span> <LocationIcon className="mx-1" />
          <span>
            {user.address && user.address.city ? user.address.city + ", " : ""}
            {user.address && user.address.state ? user.address.state + ", " : ""}
            {user.address && user.address.country === "United States of America" ? "USA" : user.address.country}
          </span>
        </p>
        <h1 className="username">{user.username}</h1>
        <div className="buttons" style={{ lineHeight: "40px" }}>
          {isSelfId(user.id) ? (
            <>
              <Link to="/settings">
                <HvButton id="edit-profile" className="btn text-uppercase btn-outline-light">
                  <EditIcon className="mr-1 mb-1" />
                  Edit Profile
                </HvButton>
              </Link>
              <RollOver text={tooltip} className="tooltip-for-profile-clipboard-modal" onMouseEnter={() => setTooltip("Copy Link")}>
                <CopyToClipBoard value={copyMe} className="btn text-uppercase btn-outline-light" onClick={() => setTooltip("Copied!")}>
                  <CopyLink className="mr-1 mb-1" />
                  <span className="copy-link position-relative">Copy Profile Link</span>
                </CopyToClipBoard>
              </RollOver>
              <RollOver text={tooltip} className="tooltip-for-profile-clipboard-modal" onMouseEnter={() => setTooltip("Copy Link")}>
                <CopyToClipBoard value={copyMeEpk} className="btn text-uppercase btn-outline-light" onClick={() => setTooltip("Copied!")}>
                  <CopyLink className="mr-1 mb-1" />
                  <span className="copy-link position-relative">My Epk Link</span>
                </CopyToClipBoard>
              </RollOver>
            </>
          ) : (
            <>
              <FollowButton className="text-white" varient="outline-light" user={user} />
              <RollOver text={tooltip} className="tooltip-for-profile-clipboard-modal" onMouseEnter={() => setTooltip("Copy Link")}>
                <CopyToClipBoard value={copyMe} className="btn text-uppercase btn-outline-light" onClick={() => setTooltip("Copied!")}>
                  <CopyLink className="mr-1 mb-1" />
                  <span className="copy-link position-relative">Copy Profile Link</span>
                </CopyToClipBoard>
              </RollOver>
              {store.getState().current_user && (
                <SendNewMessage username={user.slug} id={user.id} className="icon-btn btn btn-outline-light message-btn">
                  <NewMessage className="w-100" />
                </SendNewMessage>
              )}
              {!!user.artist_profile && !!user.artist_profile.paypal_me_tag && (user.is_subscribed_to_tipjar || user.is_subscribed_to_primo) && (
                <Link to={`/${user.slug}/tip-jar`}>
                  <HvButton className="btn btn-primary">
                    TI<span>P</span>
                  </HvButton>
                </Link>
              )}
            </>
          )}
        </div>
        <div className="following d-flex mt-3">
          <NavLink className="text-capitalize text-white" activeClassName="active" to={`/${user.slug}/followers`} exact>
            <span className="font-weight-bold">{user.followers_count}</span> followers
            <div />
          </NavLink>
          <NavLink className="text-capitalize text-white ml-4" activeClassName="active" to={`/${user.slug}/followings`} exact>
            <span className="font-weight-bold">{user.followings_count} </span>
            following
            <div />
          </NavLink>
        </div>
      </div>
    </div>
  ) : null;
};
